import _ from "lodash";
import { Anskaffningsformer, Arbetsordertyper } from "~app/common/models/constants";
import { ArbetsorderTidpunktDTO } from "~app/common/models/planera/ArbetsorderTidpunktDTO";
import { ArbetsorderVirkesorderStatus } from "~app/common/models/planera/ArbetsorderVirkesorderStatus";
import { TullkontorDTO } from "~app/common/models/tullkontor/TullkontorDto";
import { IArbetsorder } from "./IArbetsorder";
import { IOperationBase } from "./IOperationBase";

export abstract class Arbetsorder implements IArbetsorder {
    id: number;
    namn: string;
    beteckning: string;
    preliminartStartdatum: Date;
    volymArbetsorder: number;
    easting: number;
    northing: number;
    tallTimmer: number;
    granTimmer: number;
    klentimmerTall: number;
    klentimmerGran: number;
    barrmassaved: number;
    lovmassaved: number;
    tillganglighetMark: string;
    tillganglighetVag: string;
    medelstam: number;
    maskinlagId: number;
    numAtgarder: number;
    avverkningsgrupp: string;
    avverkningsgruppForkortning: string;
    containsMoreProduktgrupper: boolean;
    varningProduktionsplan: boolean;
    varningProduktionsplanTradslag: string;
    destinerad: boolean;
    produktsatt: boolean;
    koordinaterVerifierade: boolean;
    maskinikon: boolean;
    anskaffningsform: string;
    affarsform: string;
    operationer: IOperationBase[];
    typ: string;
    andelTall: number;
    andelGran: number;
    andelLov: number;
    andelContorta: number;
    avverkningFarStartaDatum: Date;
    virkesorderStatus: ArbetsorderVirkesorderStatus[];
    voContractDirty: boolean;
    arbetsorderValsSynkroniseringstatus: string;
    periodsattPeriod?: string;
    tidpunkter: ArbetsorderTidpunktDTO;
    entreprenorId?: number;
    planeringsstatus: string;
    raskVo: boolean;
    viol3: boolean;
    hasVo: boolean;

    isVirkeskop: boolean;
    isLeveransvirke: boolean;
    isTerminalImport: boolean;
    isExternArbetsorder: boolean;
    isGrotskotning: boolean;
    isAvverkning: boolean;

    isDestineringsalternativJusterad: boolean;
    antalRader: number;
    internProduktionsstatus: number;

    tullkontor: TullkontorDTO;
    isExport: boolean;
    skickadTillViol: boolean;
    dirtyProduktionsdel: boolean;
    dirtyTransportdel: boolean;
    restriktionEjKlar: boolean;
    hasTransmissionErrorProduktionViol3: boolean;
    hasTransmissionErrorTransportViol3: boolean;
    skickadTillViol3: boolean;
    egenTransport: boolean;

    constructor(arbetsorder: IArbetsorder) {
        _.assign(this, arbetsorder);
        this.isVirkeskop = Anskaffningsformer.isVirkesKop(this.anskaffningsform);
        this.isLeveransvirke = Anskaffningsformer.isVirkesKop(this.anskaffningsform) && this.typ === Arbetsordertyper.IngenProduktion;
        this.isTerminalImport = (this.anskaffningsform === Anskaffningsformer.EgenTerminal ||
            this.anskaffningsform === Anskaffningsformer.Import) &&
            this.typ === Arbetsordertyper.IngenProduktion;

        this.isExternArbetsorder = ((this.anskaffningsform === Anskaffningsformer.EgenTerminal && !this.viol3) ||
            (this.anskaffningsform === Anskaffningsformer.Import && !this.viol3) ||
            this.anskaffningsform === Anskaffningsformer.CentralaKop) &&
            this.typ === Arbetsordertyper.IngenProduktion;
        this.isGrotskotning = this.typ === Arbetsordertyper.Grotskotning;
        this.isAvverkning = this.typ === Arbetsordertyper.Avverkning;
    }
}
